// 有道云
import React from "react";
import { Card, Row } from "antd";

import Description from "./Description";

const ProQqNew2 = ({ proinfo, title }) => {
  const data = proinfo || {};
  return (
    <Card title="产品明细">
      <h3 className="order_pro_title">{title}</h3>
      <div style={{ paddingLeft: "50px" }}>
        <Row>
          <Description term="甲方主账号">{data.b_user}</Description>
          <Description term="容纳账户">{data.b_oldv}</Description>
          <Description term="服务期">{data.b_year}</Description>
        </Row>
        <Row>
          <Description term="帐号单价(元/人/月)">{data.b_money}</Description>
          <Description term="赠送空间(TB)">{data.b_memory}</Description>
          <Description term="空间加购(元/TB)">{data.b_moneys}</Description>
        </Row>
        <Row>
          <Description term="总金额大写">{data.b_name}</Description>
          <Description term="总金额">{data.bs_money}</Description>
          <Description term="大客户甲方主账号">{data.d_user}</Description>
        </Row>
        <Row>
          <Description term="大客户容纳账户">{data.d_oldv}</Description>
          <Description term="大客户服务期">{data.d_year}</Description>
          <Description term="大客户帐号单价(元/人/月)">
            {data.d_money}
          </Description>
        </Row>
        <Row>
          <Description term="大客户赠送空间(TB)">{data.d_memory}</Description>
          <Description term="大客户空间加购(元/TB)">
            {data.d_moneys}
          </Description>
          <Description term="大客户总金额大写">{data.d_name}</Description>
        </Row>
        <Row>
          <Description term="大客户总金额">{data.ds_money}</Description>
          <Description term="增加客户甲方主账号">{data.z_user}</Description>
          <Description term="增加客户增加数量">{data.z_num}</Description>
        </Row>
        <Row>
          <Description term="增加客户帐号单价(元/人/月)">
            {data.z_money}
          </Description>
          <Description term="增加客户起始日期年">{data.z_year}</Description>
          <Description term="增加客户起始日期月">{data.z_month}</Description>
        </Row>
        <Row>
          <Description term="增加客户起始日期日">{data.z_day}</Description>
          <Description term="增加客户总金额大写">{data.z_name}</Description>
          <Description term="增加客户总金额">{data.zs_money}</Description>
        </Row>
        <Row>
          <Description term="增加空间甲方主账号">{data.add_user}</Description>
          <Description term="增加空间增加容量(0:GB;1:TB)">
            {data.add_bytes}
          </Description>
          <Description term="增加空间帐号单价(元/人/月)">
            {data.add_money}
          </Description>
        </Row>
        <Row>
          <Description term="增加空间起始日期年">{data.add_year}</Description>
          <Description term="增加空间起始日期月">{data.add_month}</Description>
          <Description term="增加空间起始日期日">{data.add_day}</Description>
        </Row>
        <Row>
          <Description term="增加空间总金额大写">{data.add_name}</Description>
          <Description term="增加空间总金额">{data.adds_money}</Description>
        </Row>
      </div>
    </Card>
  );
};

export default ProQqNew2;



// WEBPACK FOOTER //
// ./src/components/xianxing/order/ProYoudao.js